import { render } from "./DocumentsView.vue?vue&type=template&id=1bf771ec"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import "./DocumentsView.vue?vue&type=style&index=0&id=1bf771ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__